/** Unpacked IES candela grid used by the real-time WebGPU renderer. */
export interface IesCandelaGrid {
  /** Azimuth angles in radians, sorted ascending. */
  azimuth: number[];
  /** Elevation angles in radians, sorted ascending. */
  elevation: number[];
  /** candela[azimuthIndex][elevationIndex] in candela (cd). */
  candela: number[][];
}

/** Wireframes are keyed by the luminaire's uuid: names are not unique (duplicates get "(copy)"). */
export interface LampWireframeTamanEntry {
  lampUuid: string;
  url: string;
  position: [number, number, number];
  iesFileId?: number;
  iesGrid?: IesCandelaGrid;
}

/** Third-party wireframe entry. Absence of url means still loading. */
export interface LampWireframeThirdPartyEntry {
  lampUuid: string;
  url?: string;
  position?: [number, number, number];
  rotationRadians?: number;
  iesGrid?: IesCandelaGrid;
}

/** Consolidated wireframes: taman (app IES) + third-party (lamp similarity) */
export interface LampWireframesState {
  versionId: number | null;
  tamanWireframes: LampWireframeTamanEntry[];
  thirdPartyWireframes: LampWireframeThirdPartyEntry[] | null;
}

export const initialLampWireframesState: LampWireframesState = {
  versionId: null,
  tamanWireframes: [],
  thirdPartyWireframes: null,
};
